var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-button',{attrs:{"type":"primary","size":"mini","circle":""},on:{"click":_vm.alert}},[_vm._v("在线编辑")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }